import axios from 'axios';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import { SocialNetwork } from '@repo/types';
import API from '../endpoints';

export const useSocialNetworksQuery = () => {
  return useQuery({ queryKey: ['socialNetworks'], queryFn: fetchSocialNetworks });
};

const fetchSocialNetworks: QueryFunction<SocialNetwork[], [string]> = async () => {
  const { data } = await axios.get<SocialNetwork[]>(API.endpoints.socialNetworks);
  return data;
};
